export default __webpack_public_path__ + "static/media/Veeva_My-Engage-en.f41be72b.mp4";